export const errorMessages = {
  'auth/email-already-in-use': 'Der findes allerede en konto med denne mail',
  'auth/invalid-email': 'E-mailadressen er ikke valid',
  'auth/user-disabled': 'Kontoen er lukket af administrator',
  'auth/user-token-expired': 'Din session er udløbet. Log ind igen for at fortsætte',
  'auth/wrong-password': 'Du er der næsten, men du har desværre indtastet det forkerte password. Prøv igen',
  'auth/user-not-found': 'Vi kan ikke finde en profil med denne mail. Prøv evt. en anden mail.'
}
